import { SelectedItemMap } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface ChipMinimizerState {
    selectedChipMinimizers: SelectedItemMap;
}

const initialState: ChipMinimizerState = {
    selectedChipMinimizers: new Map(),
};

const chipMinimizerSlice = createSlice({
    name: 'chipMinimizer',
    initialState,
    reducers: {
        resetSelectedChipMinimizers: (state) => {
            state.selectedChipMinimizers = initialState.selectedChipMinimizers;
        },
        updateSelectedChipMinimizers: (state, action: PayloadAction<SelectedItemMap>) => {
            state.selectedChipMinimizers = action.payload;
        },
    },
});

export const { resetSelectedChipMinimizers, updateSelectedChipMinimizers } = chipMinimizerSlice.actions;

export const selectSelectedChipMinimizers = ({ chipMinimizer }: RootState): SelectedItemMap =>
    chipMinimizer.selectedChipMinimizers;

export default chipMinimizerSlice.reducer;
